/**
 * Provides functionality to collapsable panel view
 */
export class CollapsablePanelController {
  public isPanelOpen: boolean;

  constructor() {
    this.activate();
  }

  /**
   * Opens and closes the panel
   */
  public togglePanel(event: any) {
    this.isPanelOpen = !this.isPanelOpen;
    const panelTransclusion = event.currentTarget.nextElementSibling;
    if (this.isPanelOpen) {
      panelTransclusion.classList.add('open');
      panelTransclusion.classList.remove('closed');
    } else {
      panelTransclusion.classList.remove('open');
      panelTransclusion.classList.add('closed');
    }
  }

  /**
   * Initiallises the state on the panel
   */
  private activate() {
    this.isPanelOpen = false;
  }
}